import services from '../../../services'

const state = {
}

const actions = {
    async getCalibrationTip({ commit }, body) {
        return await services.calibrationTip_getOne(body)
    },
    async setDisabledUser({ commit }, body) {
        return await services.calibrationTip_setDisabledUser(body)
    },
    
    async validDisabledUser({ commit }, body) {
        return await services.calibrationTip_validDisabledUser(body)
    },
}

const mutations = {
}
export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/calibrationTips.js